import type { ErrorMessageContent, PossibleErrorCodes } from './CouponErrorMessage.types';

export const possibleErrorCodes: PossibleErrorCodes = {
  SHOULD_BE_OPENED: ['BET_LINE_IS_NOT_OPENED', 'BET_OUTCOME_IS_NOT_OPENED'],
  ODD_CHANGED: ['BET_ODDS_CHANGED'],
  INSUFFICIENT_FUNDS: ['INSUFFICIENT_FUNDS'],
  BETTING_LIMITS_VIOLATION: ['BETTING_LIMITS_VIOLATION'],
};

export const errorMessageContent: ErrorMessageContent = {
  SHOULD_BE_OPENED: {
    content: ['coupon.create_error.should_be_opened', 'Bet should be opened'],
  },
  ODD_CHANGED: {
    buttonText: ['coupon.create_error.accept_odds_change', 'Accept odds change'],
    content: ['coupon.create_error.odd_changed', 'Odd is changed'],
  },
  INSUFFICIENT_FUNDS: {
    content: ['coupon.create_error.error_balance', 'Insufficient funds in the account.'],
  },
  BETTING_LIMITS_VIOLATION: {
    content: ['coupon.create_error.events_error', 'It is impossible to place bets on interdependent events'],
  },
  OUTRIGHT_EXIST: {
    content: ['coupon.add_error.outright_error', '"Outright" are not available in Express or System bets'],
  },
  ANY: {
    content: ['coupon.create_error.text', 'Failed to create coupon. Try again.'],
  },
};
